import React from "react";

import DecisionPortfolioSection from "./DecisionPortfolioSection";

const RESOLVED_STATUSES = new Set(["RESOLVED", "MONITORING"]);

export default function DecisionPortfolioSummary({ decisionMatters = [], decisionOutcomes = [] }) {
  const matters = Array.isArray(decisionMatters) ? decisionMatters : [];
  const outcomes = Array.isArray(decisionOutcomes) ? decisionOutcomes : [];
  const activeMatters = matters.filter((matter) => !RESOLVED_STATUSES.has(normalizeStatus(matter)));
  const resolvedMatters = matters.filter((matter) => RESOLVED_STATUSES.has(normalizeStatus(matter)));
  const measured = outcomes.filter((outcome) => outcome?.measurementStatus === "MEASURED").length;

  return (
    <section aria-labelledby="board-decision-portfolio-heading" className="rounded-xl border border-slate-200 bg-slate-50 p-6">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Executive governance</p>
      <h2 id="board-decision-portfolio-heading" className="mt-2 text-xl font-semibold text-slate-950">Executive Decision Portfolio</h2>
      <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600">The complete portfolio of decisions and their current governance lifecycle.</p>
      <div aria-label="Decision portfolio overview" className="mt-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        <SummaryValue label="Total Decisions" value={matters.length} />
        <SummaryValue label="Active Decisions" value={activeMatters.length} />
        <SummaryValue label="Resolved Decisions" value={resolvedMatters.length} />
        <SummaryValue label="Monitoring Outcomes" value={outcomes.length} />
      </div>
      {!matters.length ? <p className="mt-6 rounded-lg border border-dashed border-slate-300 bg-white p-5 text-sm text-slate-600">No decisions available.</p> : (
        <div className="mt-7 space-y-8">
          <DecisionPortfolioSection title="Active Decisions" matters={activeMatters} outcomes={outcomes} />
          <DecisionPortfolioSection title="Resolved Decisions" matters={resolvedMatters} outcomes={outcomes} />
        </div>
      )}
      <section aria-labelledby="outcome-monitoring-overview" className="mt-8 border-t border-slate-200 pt-6">
        <h3 id="outcome-monitoring-overview" className="text-base font-semibold text-slate-950">Outcome Monitoring</h3>
        {!outcomes.length ? <p className="mt-3 text-sm text-slate-600">No outcomes available.</p> : (
          <div aria-label="Outcome monitoring summary" className="mt-4 grid gap-3 sm:grid-cols-3">
            <SummaryValue label="Decisions Monitored" value={outcomes.length} />
            <SummaryValue label="Pending Measurement" value={outcomes.length - measured} />
            <SummaryValue label="Measured" value={measured} />
          </div>
        )}
      </section>
    </section>
  );
}

function normalizeStatus(matter) { return String(matter?.governanceStatus || matter?.status || "DRAFT").trim().toUpperCase(); }

function SummaryValue({ label, value }) {
  return <div className="rounded-lg border border-slate-200 bg-white p-4"><p className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">{label}</p><p className="mt-2 text-2xl font-semibold text-slate-950">{value}</p></div>;
}
